<div class="redeem-cash-success-details rounded-md p-6">
  <ng-container [ngSwitch]="status">
    <ng-container *ngSwitchCase="OrderItemStatus.Fulfilled">
      <div class="redeem-amount-container">
        <ng-container *ngIf="hasDiscount; else noDiscount"
          ><div class="redeem-amount my-0">
            <span class="sr-only">{{
              'promocode.discounted_transfer_amount.aria_label'
                | translate
                  : {
                      value: redeemAmountString(redeemCashOrder.pointsPaid)
                    }
            }}</span>
            <span aria-hidden="true">
              {{
                'redeem_cash_v2.success.redeem_amount'
                  | translate: redeemAmountParams(redeemCashOrder.pointsPaid)
              }}
            </span>
          </div>

          <div class="my-0 text-sm text-[#747678] line-through">
            <span class="sr-only">{{
              'promocode.original_transfer_amount.aria_label'
                | translate
                  : { value: redeemAmountString(redeemCashOrder.pointsAmount) }
            }}</span>
            <span aria-hidden="true">
              {{
                'redeem_cash_v2.success.redeem_amount'
                  | translate: redeemAmountParams(redeemCashOrder.pointsAmount)
              }}
            </span>
          </div>

          <div
            class="mt-[5px] text-[14px] font-semibold text-[#008A02]"
            tabindex="0"
            [attr.aria-label]="
              'promocode.code.aria_label'
                | translate: { value: redeemCashOrderItemData.promoCode }
            ">
            <rd-shared-icon
              class="mr-2 inline-block h-4 w-4 align-middle"
              iconSymbol="icon-promocode"
              iconTheme="primary"></rd-shared-icon>
            <span aria-hidden="true" class="align-middle">
              {{ redeemCashOrderItemData.promoCode }}
            </span>
          </div></ng-container
        >
        <ng-template #noDiscount>
          <div
            class="redeem-amount my-0"
            [attr.aria-label]="
              'redeem_cash_v2.success.redeem_amount'
                | translate: redeemAmountParams(redeemCashOrder.pointsPaid)
            ">
            <span aria-hidden="true">
              {{
                'redeem_cash_v2.success.redeem_amount'
                  | translate: redeemAmountParams(redeemCashOrder.pointsPaid)
              }}
            </span>
          </div>
        </ng-template>
      </div>
      <p class="delivery-message-reminder m-0">
        {{
          'redeem_cash_v2.success.reminder'
            | translate: { processingDelay: this.processingDelay }
        }}
      </p>
      <ng-container *ngIf="shouldDisplayMembershipDetailsOnSuccessPage">
        <ng-container [ngSwitch]="redeemCashOrderItemData.membership?.category">
          <rd-shared-dynamic-list
            *ngSwitchCase="LoyaltyProgramCategory.CashbackToCard"
            [items]="redeemToCardDetails"
            [ariaHidden]="true"
            [listAriaLabel]="
              selectedEnrollmentAccountAriaLabelInConfirmationPage(
                redeemCashOrderItemData
              )
            "></rd-shared-dynamic-list>

          <rd-shared-dynamic-list
            *ngSwitchCase="LoyaltyProgramCategory.CashbackToAccount"
            [items]="redeemToAccountDetails"
            [ariaHidden]="true"
            [listAriaLabel]="
              'accessibility.redeem_cash_v2.success.redeem_to_account_details'
                | translate
                  : {
                      firstName:
                        redeemCashOrderItemData.membership?.firstName ?? '',
                      lastName:
                        redeemCashOrderItemData.membership?.lastName ?? '',
                      bsbNumber: bsbNumber,
                      digits: redeemCashOrderItemData.membership?.number ?? ''
                    }
            "></rd-shared-dynamic-list>

          <rd-shared-dynamic-list
            *ngSwitchCase="LoyaltyProgramCategory.CashbackToPlatform"
            [items]="redeemToPlatformDetails"
            [ariaHidden]="true"
            [listAriaLabel]="
              'accessibility.redeem_cash_v2.success.redeem_to_platform_details'
                | translate
                  : {
                      firstName:
                        redeemCashOrderItemData.membership?.firstName ?? '',
                      lastName:
                        redeemCashOrderItemData.membership?.lastName ?? '',
                      email: redeemCashOrderItemData.membership?.number ?? ''
                    }
            "></rd-shared-dynamic-list>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="OrderItemStatus.Failed">
      <p class="delivery-failed m-0">
        {{
          'redeem_cash_v2.success.refunded_message'
            | translate: redeemAmountParams(redeemCashOrder.pointsPaid)
        }}
      </p>
    </ng-container>
  </ng-container>
</div>
